module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.modifyLocation($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "margin-top-20 row search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apps), function(app) {
    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(app.app_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "md-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (app.location_access),
        expression: "app.location_access"
      }],
      staticClass: "md-check",
      attrs: {
        "type": "checkbox",
        "id": ("app_access_location_" + (app.app_id))
      },
      domProps: {
        "checked": Array.isArray(app.location_access) ? _vm._i(app.location_access, null) > -1 : (app.location_access)
      },
      on: {
        "change": function($event) {
          var $$a = app.location_access,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (app.location_access = $$a.concat([$$v]))
            } else {
              $$i > -1 && (app.location_access = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(app, "location_access", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("app_access_location_" + (app.app_id))
      }
    }, [_c('span'), _vm._v(" "), _c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    })])])])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Roles Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\tAssign App Access\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click font-grey-mint"
  }, [_vm._v("Include App")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48650906!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MyBusiness/Locations/LocationAppAccess.vue
// module id = 427
// module chunks = 1